import { LoaderIcon } from '@/app/features/icons/Loader'
import { getGroupedViolationsColumnsDetailsNew } from '@/modules/drivers/constants/tables'
import { useSortableData } from '@/modules/drivers/hooks/useSortTable'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import React from 'react'
import TableEmpty from '@/modules/drivers/shared/tableItems/TableEmpty'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { ViolationDetailsRow } from './ViolationDetailsRow'

const ViolationDetailsTable = ({
  violations,
  isLoadingDetails,
}) => {
  const { t } = useLocalize()
  const columns = getGroupedViolationsColumnsDetailsNew(t)

  const { range } = useDate()

  const { sortedData, sortConfig, handleHeaderClick } = useSortableData({
    data: violations,
    tableColumns: columns,
  })

  const filteredByRange = React.useMemo(() => {
    if (!range?.startDate || !range?.endDate) return sortedData

    const rangeStart = new Date(
      range.startDate.year,
      range.startDate.month - 1,
      range.startDate.day,
    )
    const rangeEnd = new Date(
      range.endDate.year,
      range.endDate.month - 1,
      range.endDate.day,
      23,
      59,
      59,
    )

    return sortedData.filter((v) => {
      const vStart = v.startTime ? new Date(v.startTime) : null
      const vEnd = v.endTime ? new Date(v.endTime) : null
      if (!vStart) return false
      const end = vEnd || vStart
      return end >= rangeStart && vStart <= rangeEnd
    })
  }, [sortedData, range])

 
  return (
    <section className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
      {isLoadingDetails ? (
        <div className="tw-grid tw-h-full tw-place-items-center">
          <LoaderIcon className="tw-w-16 tw-animate-spin" />
        </div>
      ) : filteredByRange.length > 0 ? (
        <div className="tw-flex tw-flex-1 tw-flex-col tw-overflow-y-auto">
          <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2">
            <TableHeader
              opacity
              sticky
              rounded={false}
              disabledCheckboxToggle
              columns={columns}
              sortConfig={sortConfig}
              onHeaderClick={handleHeaderClick}
            />

            <tbody>
              {filteredByRange.map((violation, i) => (
                <ViolationDetailsRow
                  key={
                    violation?.id ??
                    `${violation?.driverId ?? 'unknown'}-${violation?.startTime ?? ''}-${i}`
                  }
                  violation={violation}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <TableHeader
            opacity
            disabledCheckboxToggle
            columns={columns}
            sortConfig={null}
          />
          <TableEmpty title={t('driverModule.no-violations-in-period')} />
        </>
      )}
    </section>
  )
}

export default ViolationDetailsTable
